import Handlebars from 'lib/handlebars.runtime-v2.0.0';

export default Handlebars.registerHelper('lower', function lower(string) {
  return typeof string === 'string' ? string.toLowerCase() : string;
});
